import { has } from 'lodash/fp';
import { capitalize } from 'utils/string_utils';
import { PATH_BUILDER } from '../../constants/actionTypes';

const initialState = {
  editingTaggings: false,
  editingOwnerships: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case PATH_BUILDER.UI.TOGGLE_EDITING_BY_NAME: {
      const key = `editing${capitalize(action.name)}`;
      return {
        ...state,
        [key]: has(key, state) ? !state[key] : true,
      };
    }

    default:
      return state;
  }
};
